/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ElectricInputs */

const en_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electric`)
};

const es_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eléctrico`)
};

const fr_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Électrique`)
};

const de_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektrisch`)
};

const ja_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電気`)
};

const zh_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电动`)
};

const ar_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كهربائي`)
};

const id_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listrik`)
};

const it_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elettrico`)
};

const ru_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электро`)
};

const pt_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elétrico`)
};

const ko_val_electric = /** @type {(inputs: Val_ElectricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전기`)
};

/**
* | output |
* | --- |
* | "Electric" |
*
* @param {Val_ElectricInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_electric = /** @type {((inputs?: Val_ElectricInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ElectricInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_electric(inputs)
	if (locale === "es") return es_val_electric(inputs)
	if (locale === "fr") return fr_val_electric(inputs)
	if (locale === "de") return de_val_electric(inputs)
	if (locale === "ja") return ja_val_electric(inputs)
	if (locale === "zh") return zh_val_electric(inputs)
	if (locale === "ar") return ar_val_electric(inputs)
	if (locale === "id") return id_val_electric(inputs)
	if (locale === "it") return it_val_electric(inputs)
	if (locale === "ru") return ru_val_electric(inputs)
	if (locale === "pt") return pt_val_electric(inputs)
	return ko_val_electric(inputs)
});